import '@babel/polyfill';
import './ui/css3-animate-it';
import './ui/forms';
import './ui/lazy';
import './ui/owl-carousel';
import 'flexslider';
import 'jquery-datetimepicker';
import 'lazysizes';
import 'magnific-popup';
import picturefill from 'picturefill';
import Plyr from 'plyr/dist/plyr.polyfilled.js';
import initUI from './ui/ui';
import './algolia/header';
import './algolia/search';
import './algolia/furniture';
import './algolia/textiles';
import initializeProductVariants from './ui/product-variants';

require('intersection-observer');

const player = new Plyr('.plyr');

initUI();
initializeProductVariants();

// FITVIDS
!function(o){"use strict";o.fn.fitVids=function(t){var e,i,d={customSelector:null,ignore:null};return document.getElementById("fit-vids-style")||(e=document.head||document.getElementsByTagName("head")[0],(i=document.createElement("div")).innerHTML='<p>x</p><style id="fit-vids-style">.fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}</style>',e.appendChild(i.childNodes[1])),t&&o.extend(d,t),this.each(function(){var t=['iframe[src*="player.vimeo.com"]','iframe[src*="youtube.com"]','iframe[src*="youtube-nocookie.com"]','iframe[src*="kickstarter.com"][src*="video.html"]',"object","embed"];d.customSelector&&t.push(d.customSelector);var r=".fitvidsignore";d.ignore&&(r=r+", "+d.ignore);t=o(this).find(t.join(","));(t=(t=t.not("object object")).not(r)).each(function(){var t,e,i=o(this);0<i.parents(r).length||"embed"===this.tagName.toLowerCase()&&i.parent("object").length||i.parent(".fluid-width-video-wrapper").length||(i.css("height")||i.css("width")||!isNaN(i.attr("height"))&&!isNaN(i.attr("width"))||(i.attr("height",9),i.attr("width",16)),t=("object"===this.tagName.toLowerCase()||i.attr("height")&&!isNaN(parseInt(i.attr("height"),10))?parseInt(i.attr("height"),10):i.height())/(isNaN(parseInt(i.attr("width"),10))?i.width():parseInt(i.attr("width"),10)),i.attr("name")||(e="fitvid"+o.fn.fitVids._count,i.attr("name",e),o.fn.fitVids._count++),i.wrap('<div class="fluid-width-video-wrapper"></div>').parent(".fluid-width-video-wrapper").css("padding-top",100*t+"%"),i.removeAttr("height").removeAttr("width"))})})},o.fn.fitVids._count=0}(window.jQuery||window.Zepto);
$(document).ready(function(){
    $(".module-video").fitVids();
});

function closeAllNav() {
    $('.nav-full').fadeOut().attr('aria-hidden', 'true');
    $('.nav-overlay').fadeOut();
    $('.nav-full ul ul').fadeOut().attr('aria-hidden', 'true');
    $('.toggle-menu').removeClass('is-active').attr('aria-expanded', 'false');
    $('.nav-full .has-children > a').removeClass('on').attr('aria-expanded', 'false');
    $('#navigation').removeClass('level1-open').removeClass('level2-open');
    $('html').removeClass('nav-active');
}
function closeSearch() {
    $('.search-form').hide().attr('aria-hidden', 'true');
    $('.toggle-search').removeClass('is-active').attr('aria-expanded', 'false');
    $('html').removeClass('search-active');
}
function closeSubscribe() {
    $('#subscribe').fadeOut();
    $('.modal-overlay').fadeOut();
    $('.toggle-subscribe').removeClass('is-active');
    $('html').removeClass('subscribe-active');
}
$.fn.isOnScreen = function() {
    const win = $(window);
    const viewport = {
        top: win.scrollTop(),
        left: win.scrollLeft(),
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    const bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();
    return !(
        viewport.right < bounds.left ||
        viewport.left > bounds.right ||
        viewport.bottom < bounds.top ||
        viewport.top > bounds.bottom
    );
};

// MAIN NAV
// toggle
if ($('.toggle-menu').length > 0) {
    $('.toggle-menu').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        if ($(this).hasClass('is-active')) {
            closeAllNav();
        } else {
            $(this).addClass('is-active').attr('aria-expanded', 'true');
            $(target).fadeIn().attr('aria-hidden', 'false');
            $('.nav-overlay').fadeIn();
            $('html').addClass('nav-active');
            closeSearch();
        }
    });
}
// close dropdowns elsewhere
$(document).bind('mouseup touchend', function(e) {
    const container = $('.toggle-menu, #navigation');
    if (
        !container.is(e.target) && // if the target of the click isn't the container...
        container.has(e.target).length === 0
    ) {
        // ... nor a descendant of the container
        closeAllNav();
    }
});
// first level
if ($('.nav-full .level1').length > 0) {
    $('.nav-full .level1.has-children > a').on('click', function(e) {
        e.preventDefault();
        const target = $(this).next('ul');
        $('#navigation').removeClass('level2-open');
        if ($(this).hasClass('on')) {
            $(this).removeClass('on').attr('aria-expanded', 'false');
            $(target).slideUp().attr('aria-hidden', 'true');
            $('#navigation').removeClass('level1-open');
        } else {
            $('.nav-full .has-children > a').removeClass('on').attr('aria-expanded', 'false');
            $('.nav-full ul ul').slideUp().attr('aria-hidden', 'true');
            $(this).addClass('on').attr('aria-expanded', 'true');
            $(target).slideDown().attr('aria-hidden', 'false');
            $('#navigation').addClass('level1-open');
        }
    });
}
// second level
if ($('.nav-full .level2').length > 0) {
    $('.nav-full .level2.has-children > a').on('click', function(e) {
        e.preventDefault();
        const target = $(this).next('ul');
        if ($(this).hasClass('on')) {
            $(this).removeClass('on').attr('aria-expanded', 'false');
            $(target).slideUp().attr('aria-hidden', 'true');
            $('#navigation').removeClass('level2-open');
        } else {
            $('.nav-full .level2.has-children > a').removeClass('on').attr('aria-expanded', 'false');
            $('.nav-full ul ul ul').slideUp().attr('aria-hidden', 'true');
            $(this).addClass('on').attr('aria-expanded', 'true');
            $(target).slideDown().attr('aria-hidden', 'false');
            $('#navigation').addClass('level2-open');
        }
    });
}

// TOGGLE SEARCH
if ($('.toggle-search').length > 0) {
    $('.toggle-search').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        if ($(this).hasClass('is-active')) {
            closeSearch();
        } else {
            $(this).addClass('is-active').attr('aria-expanded', 'true');
            $(target).show().attr('aria-hidden', 'false');
            $('#search-box .ais-SearchBox-input').focus();
            $('html,body').animate({ scrollTop: $('header').offset().top }, 500, 'linear');
            $('html').addClass('search-active');
            closeAllNav();
            fbq('track', 'Search', {});
        }
    });
}
if ($('.search-form .escape').length > 0) {
    $('.search-form .escape').on('click', function(e) {
        e.preventDefault();
        closeSearch();
    });
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27) {
            closeSearch();
        }
    });
}

document.addEventListener('afterBlitzInjectAll', function(event) {
    $('#paymentCurrency1').on('change', function() {
        $('#currency-converter1').submit();
    });
    $('#paymentCurrency2').on('change', function() {
        $('#currency-converter2').submit();
    });
});

// TOGGLE SUBSCRIBE
if ($('.toggle-subscribe').length > 0) {
    $('.auto-subscribe, .toggle-subscribe').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        if ($(this).hasClass('is-active')) {
            closeSubscribe();
        } else {
            $('.toggle-subscribe').addClass('is-active');
            $(target).fadeIn();
            $('.modal-overlay').fadeIn();
            $('html').addClass('subscribe-active');
        }
    });
    $('.modal-overlay').on('click', function(e) {
        e.preventDefault();
        closeSubscribe();
    });
    $(document).on('keydown', function(e) {
        if (e.keyCode === 27) {
            closeSubscribe();
        }
    });
}

// TOGGLE FILTERS
if ($('.filters-wrap').length > 0) {
    // toggle filters
    $('.toggle-filters').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        if ($(this).hasClass('is-active')) {
            $('#category .ais-refinement-list--body').slideUp();
            $('#collection .ais-refinement-list--body').slideUp();
            $('#color .ais-refinement-list--body').slideUp();
            $('#featured .ais-refinement-list--body').slideUp();
            $('#style .ais-refinement-list--body').slideUp();
            $('#coordinatingFinishes .ais-refinement-list--body').slideUp();
            $('#durability .ais-refinement-list--body').slideUp();
            $('#price .ais-refinement-list--body').slideUp();
            $('.ais-refinement-list--header').removeClass('is-active');
            $('#current-refined-values + .clear').slideDown();
            $('.filters-wrap').removeClass('is-active');
            $('.toggle-filters').removeClass('is-active').attr('aria-expanded', 'false');
            $(target).slideUp().attr('aria-hidden', 'true');
        } else {
            $('#current-refined-values + .clear').slideUp();
            $('.filters-wrap').addClass('is-active');
            $('.toggle-filters').addClass('is-active').attr('aria-expanded', 'true');
            $(target).slideDown().attr('aria-hidden', 'false');
        }
    });
    // "Apply Filters"
    $('.js-apply-filters').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        $('#category .ais-refinement-list--body').slideUp();
        $('#collection .ais-refinement-list--body').slideUp();
        $('#color .ais-refinement-list--body').slideUp();
        $('#featured .ais-refinement-list--body').slideUp();
        $('#style .ais-refinement-list--body').slideUp();
        $('#coordinatingFinishes .ais-refinement-list--body').slideUp();
        $('#durability .ais-refinement-list--body').slideUp();
        $('#price .ais-refinement-list--body').slideUp();
        $('.ais-refinement-list--header').removeClass('is-active');
        $('#current-refined-values + .clear').slideDown();
        $('.filters-wrap').removeClass('is-active');
        $('.toggle-filters')
            .removeClass('is-active')
            .attr('aria-expanded', 'false');
        $(target)
            .slideUp()
            .attr('aria-hidden', 'true');
    });
    // "Clear Filters"
    $('.js-clear-filters').on('click', function(e) {
        e.preventDefault();
        $('#clear-refinements button').click();
    });
    // toggle compare
    $('.toggle-compare').on('change', function(e) {
        if ($(this).is(':checked')) {
            $('body').addClass('furniture-compare');
        } else {
            $(this).prop('checked', false);
            $('body').removeClass('furniture-compare');
        }
    });
    $('.toggle-compare-off').on('click', function(e) {
        e.preventDefault();
        $('.toggle-compare').prop('checked', false);
        $('body').removeClass('furniture-compare');
    });
    
    // toggle refinements (mobile-only)
    $('#category .ais-refinement-list--header, #collection .ais-refinement-list--header, #color .ais-refinement-list--header, #featured .ais-refinement-list--header, #style .ais-refinement-list--header, #coordinatingFinishes .ais-refinement-list--header, #durability .ais-refinement-list--header, #price .ais-refinement-list--header').on('click', function(e) {
        e.preventDefault();
        const target = $(this).next('.ais-refinement-list--body');
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            $(target).slideUp();
        } else {
            $('#category .ais-refinement-list--body').slideUp();
            $('#collection .ais-refinement-list--body').slideUp();
            $('#color .ais-refinement-list--body').slideUp();
            $('#featured .ais-refinement-list--body').slideUp();
            $('#style .ais-refinement-list--body').slideUp();
            $('#coordinatingFinishes .ais-refinement-list--body').slideUp();
            $('#durability .ais-refinement-list--body').slideUp();
            $('#price .ais-refinement-list--body').slideUp();
            $('.ais-refinement-list--header').removeClass('is-active');
            $(this).addClass('is-active');
            $(target).slideDown();
        }
    });
}

// ACTIVATE HEADER ON SCROLL
$(window).scroll(function() {
    const scroll = $(window).scrollTop();
    if (scroll >= 15) {
        $('html').addClass('scroll-active');
    } else {
        $('html').removeClass('scroll-active');
    }
}); // missing );

// SCROLL TO ARROWS
if ($('.scroll-to').length > 0) {
    $('.scroll-to').on('click', function(e) {
        e.preventDefault();
        $('html,body').animate(
            {
                scrollTop: $($(this).attr('href')).offset().top,
            },
            500,
            'linear'
        );
    });
}

// SCROLL TO ANCHORS
if ($('.module-text a[href^="#"]').length > 0) {
    $('.module-text a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        $('html,body').animate(
            {
                scrollTop: $($(this).attr('href')).offset().top,
            },
            500,
            'linear'
        );
    });
}
if ($('.module-catblocks a[href^="#"]').length > 0) {
    $('.module-catblocks a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        $('html,body').animate(
            {
                scrollTop: $($(this).attr('href')).offset().top,
            },
            500,
            'linear'
        );
    });
}

// ACCORDIONS
if ($('.module-accordion .accordion-group h2 a, .module-accordion .accordion-group .h2 a').length > 0) {
    $('.module-accordion .accordion-group h2 a, .module-accordion .accordion-group .h2 a').on('click', function(e) {
        e.preventDefault();
        const target = $(this).attr('href');
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active').attr('aria-expanded', 'false');
            $(this).children('img').attr('src', '/assets/images/icon-plus.svg').attr('alt', 'Open');
            $(target).slideUp().attr('aria-hidden', 'true');
        } else {
            $(this).addClass('is-active').attr('aria-expanded', 'true');
            $(this).children('img').attr('src', '/assets/images/icon-minus.svg').attr('alt', 'Close');
            $(target).slideDown().attr('aria-hidden', 'false');
        }
    });
}

// VIDEO LIBRARY
if ($('.mfp-video').length > 0) {
    $('.mfp-video').magnificPopup({
        type: 'inline',
        midClick: true,
        callbacks: {
            close() {
                player.stop();
            },
        },
    });
}

// "STICKY" SHARING ICONS
if ($('.module-journal-title .sharing').length > 0) {
    $(window).scroll(function() {
        const scroll = $(window).scrollTop();
        if ($('.module-more-posts figure').isOnScreen() || $('footer').isOnScreen()) {
            // fade out when the post ends
            $('.content .sharing.fixed').addClass('hide');
        } else if (scroll >= 810) {
            $('.content .sharing.static').fadeOut();
            $('.content .sharing.fixed').removeClass('hide');
        } else {
            $('.content .sharing.static').fadeIn();
            $('.content .sharing.fixed').addClass('hide');
        }
    });
}

// TRADE REGISTRATION
/* if($('#tradeMember').length > 0) {
    $('#tradeMember').prop('checked',false);
    $('#tradeMember').change(function() {    
        "use strict";
        if($('#tradeMember').is(':checked')) {  
            $('.trade-fields').show();
            $('.required').attr('required','required');
        }
        else {
            $('.trade-fields').hide();
            $('.required').removeAttr('required');
        }
    });
    $('.module-register .button.button-plain').on('click', function(){
        "use strict";
        $('.trade-fields').hide();
        $('.required').removeAttr('required');
        $('#tradeMember').prop('checked',false);
    });
} */

// SLIDESHOWS
if ($('.module-slideshow .flexslider').length > 0) {
    $('.module-slideshow .flexslider').flexslider({
        selector: '.slides > .slide',
        animation: 'slide',
        smoothHeight: false,
        slideshow: false,
    });
}
if ($('.page-banner-links .owl-carousel').length > 0) {
    $('.page-banner-links .owl-carousel').owlCarousel({
        animateOut: 'fadeOut',
        autoplay: true,
        center: true,
        dots: false,
        items: 1,
        loop: true,
        margin: 0,
    });
}
if ($('.page-banner-slides .owl-carousel').length > 0) {
    $('.page-banner-slides .owl-carousel').owlCarousel({
        autoplay: false,
        center: true,
        center: true,
        dots: true,
        dotsContainer: '.pbslides-dots',
        items: 1,
        lazyLoad: true,
        lazyLoadEager: 1,
        loop: true,
        margin: 0,
        nav: true,
        navContainer: '.pbslides-nav',
    });
}
if ($('.module-3slides .owl-carousel').length > 0) {
    $('.module-3slides .owl-carousel').owlCarousel({
        autoplay: false,
        center: true,
        dots: true,
        dotsContainer: '.3slides-dots',
        lazyLoad: true,
        lazyLoadEager: 1,
        loop: true,
        nav: true,
        navContainer: '.3slides-nav',
        responsive : {
            // breakpoint from 0 up
            0 : {
                items: 1,
                margin: 0,
            },
            // breakpoint from 825 up
            825 : {
                items: 3,
                margin: 30,
            },
        }
    });
}
if ($('.module-showousel .owl-carousel.mobile').length > 0) {
    $('.module-showousel .owl-carousel.mobile').owlCarousel({
        autoplay: false,
        center: true,
        dots: true,
        dotsContainer: '.showousel-dots-mobile',
        items: 1,
        lazyLoad: true,
        lazyLoadEager: 1,
        loop: true,
        margin: 0,
        nav: true,
        navContainer: '.showousel-nav-mobile',
    });
}
if ($('.module-showousel .owl-carousel.desktop').length > 0) {
    $('.module-showousel .owl-carousel.desktop').owlCarousel({
        autoplay: false,
        center: true,
        dots: true,
        dotsContainer: '.showousel-dots-desktop',
        lazyLoad: true,
        lazyLoadEager: 1,
        loop: true,
        margin: 30,
        nav: true,
        navContainer: '.showousel-nav-desktop',
        stagePadding: 203.033,
        responsive : {
            // breakpoint from 1000 up
            1000 : {
                items: 1,
            },
            // breakpoint from 1700 up
            1700 : {
                items: 1,
            },
            // breakpoint from 3400 up
            3400 : {
                items: 1,
            },
        }
    });
}

// CURRENCY CONVERTERS
if ($('#currency-converter1').length > 0) {
    $('#paymentCurrency1').on('change', function() {
        $('#currency-converter1').submit();
    });
}
if ($('#currency-converter2').length > 0) {
    $('#paymentCurrency2').on('change', function() {
        $('#currency-converter2').submit();
    });
}

// PORTFOLIO
if ($('.module-portfolio .quote-button').length > 0) {
    $('.module-portfolio .quote-button').on('click', function(e) {
        e.preventDefault();
        $('.share-button').attr('aria-expanded', 'false');
        $('#share-your-portfolio')
            .hide()
            .attr('aria-hidden', 'true');
        $('.quote-button').attr('aria-expanded', 'true');
        $('#quote-your-portfolio')
            .show()
            .attr('aria-hidden', 'false');
        $('html,body').animate({ scrollTop: $('#quote-target').offset().top }, 500, 'linear');
    });
}
if ($('.module-portfolio .share-button').length > 0) {
    $('.module-portfolio .share-button').on('click', function(e) {
        e.preventDefault();
        $('.quote-button').attr('aria-expanded', 'false');
        $('#quote-your-portfolio')
            .hide()
            .attr('aria-hidden', 'true');
        $('.share-button').attr('aria-expanded', 'true');
        $('#share-your-portfolio')
            .show()
            .attr('aria-hidden', 'false');
        $('html,body').animate(
            {
                scrollTop: $('#share-target').offset().top,
            },
            500,
            'linear'
        );
    });
}
if ($('.module-portfolio .download-button').length > 0) {
    $('.module-portfolio .download-button').on('click', function(e) {
        $(this).html('Generating .zip, please wait...');
    });
}

// CONTACT LINKS
if ($('a[href^="mailto:"]').length > 0) {
    $('a[href^="mailto:"]').on('click', function() {
        fbq('track', 'Contact', {});
    });
}
if ($('a[href^="tel:"]').length > 0) {
    $('a[href^="tel:"]').on('click', function() {
        fbq('track', 'Contact', {});
    });
}

// DATE/TIME PICKER
if ($('#datetime').length > 0) {
    $('#datetime').datetimepicker({
        format: 'F j, Y g:ia',
        // inline:true,
        lang: 'en',
        step: 15,
        disabledWeekDays: [0, 6],
        minTime: '09:00:00',
        formatTime: 'g:ia',
        maxTime: '17:31:00',
        formatTime: 'g:ia',
    });
}

// STATE TO EMAILS
if ($('.state-dropdown').length > 0) {
    $(document).ready(function() {
        $('.state-dropdown').on('change', function() {
            var selectedValue = $(this).find('option:selected').text();
            $('.state-input').val(selectedValue);
        });
    });
}

// BANNER WRAPS
if ($('.page-banner.page-banner-image .wrapper .text').length > 0) {
    $('.page-banner.page-banner-image .wrapper .text').wrap('<div class="twrap1"><div class="twrap2"></div></div>');
}

// QUANTITY
$('<div class="quantity-button quantity-up">+</div><div class="quantity-button quantity-down">-</div>').insertAfter('.quantity input');
$('.quantity').each(function() {
  var spinner = jQuery(this),
    input = spinner.find('input[type="number"]'),
    btnUp = spinner.find('.quantity-up'),
    btnDown = spinner.find('.quantity-down'),
    min = input.attr('min'),
    max = input.attr('max');

  btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

  btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").val(newVal);
    spinner.find("input").trigger("change");
  });

});